<script setup lang="ts">
import { ref } from 'vue'
import BuyCodeModal from '@/components/dashboard/BuyCodeModal.vue'

const open = ref(false)
</script>

<template>
  <button
    type="button"
    class="panel flex items-center gap-2 !py-3 !px-4 transition hover:border-primary hover:bg-primary/5"
    @click="open = true"
  >
    <span class="badge badge-outline-primary">＋</span>
    <span class="text-sm font-bold">Купить код активации</span>
  </button>

  <BuyCodeModal :open="open" @close="open = false" />
</template>
